const { classNames } = Mobi2Go.helpers;

const getStyles = (icon, max_length, input_focused) => ({
    mobile: {
        container: classNames(
            'm2g-list-cell',
            'm2g-list-cell--with-top-border',
            'm2g-list-cell--text-input'
        ),
        input: 'm2g-list-cell__input',
        icon: `m2g-list-cell__icon m2g-list-cell__icon--left m2g-icon m2g-icon--${icon}`,
        counter: classNames(
            'm2g-input-char-counter-container',
            'm2g-list-cell__content',
            'm2g-list-cell__content--small'
        ),
    },
    desktop: {
        container: classNames(
            'm2g-input-container',
            { 'm2g-input-container--with-char-counter': max_length },
            'm2g-form-element--full-width'
        ),
        input: 'm2g-input',
        icon: `m2g-icon m2g-icon--${icon}`,
        counter: classNames('m2g-input-char-counter-container', {
            hidden: !input_focused,
        }),
    },
});

export default getStyles;
